// Generated by CoffeeScript 1.12.7
(function () {
  Viewthespace.Flash = (function () {
    Flash.fadeOut = function (flashType) {
      if ($(".flash").attr("data-must-be-read") === "true") {
        return $(".flash-cancel").click(function () {
          return $("#flash-required").hide();
        });
      } else {
        return setTimeout(function () {
          return $("#flash").fadeOut("slow", function () {
            if (flashType) {
              return $(this)
                .find("." + flashType)
                .remove();
            }
          });
        }, 8000);
      }
    };

    Flash.setWidth = function () {
      return $("#flash .flash").each(function () {
        var $notice;
        $notice = $(this);
        if ($notice.text() != null && $notice.text().length > 0) {
          $notice.css("width", $notice.textWidth() + "px");
          $notice.css("min-width", "250px");
          return $notice.css("max-width", "600px");
        }
      });
    };

    function Flash(message, flashType) {
      if (flashType == null) {
        flashType = "notice";
      }
      this.flashDiv = $("#flash");
      this.flashType = flashType;
      this.message = message;
    }

    Flash.prototype.show = function () {
      var $notice;
      if (this.message != null && this.message.length > 0) {
        this.flashDiv.find("." + this.flashType).remove();
        $notice = $("<div>")
          .addClass("flash")
          .addClass(this.flashType)
          .text(this.message.toString().replace(/\+/g, " "));
        $notice.appendTo(this.flashDiv);
        this.flashDiv.show();
        Viewthespace.Flash.setWidth();
        return Viewthespace.Flash.fadeOut(this.flashType);
      }
    };

    return Flash;
  })();

  jQuery(function () {
    Viewthespace.Flash.setWidth();
    return Viewthespace.Flash.fadeOut();
  });
}.call(this));
